// @flow
import styled from "styled-components"
import { SubTitle } from "componentsStyled/Typography/Titles"

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3rem;

  justify-content: space-between;
  height: 65rem;

  form {
    width: 100%;
  }

  * {
    box-shadow: none;
  }
`

export const H2 = styled(SubTitle)`
  font-weight: ${p => p.bold ? p.theme.fontWeights.bold : 350};
  letter-spacing: 0.1rem;
  margin-top: 0.5rem;
  text-transform: none;
`



// WEBPACK FOOTER //
// ./src/modals/SubscribePlan/styled.js